module.exports = __webpack_public_path__ + "static/media/img-01.e778a3df.png";